import Vue from 'vue'
import Vuex from 'vuex'
import AppStoreGlobal from '@/app/app-store-global'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    AppStoreGlobal
  }
})
